import { render, staticRenderFns } from "./InputIcon.vue?vue&type=template&id=5be52ff5&"
import script from "./InputIcon.vue?vue&type=script&lang=js&"
export * from "./InputIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports